import { render, staticRenderFns } from "./snap01.vue?vue&type=template&id=6ff98de2"
import script from "./snap01.vue?vue&type=script&lang=js"
export * from "./snap01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports